(function () {
  var BLUE_COLORS  = ['#0070ba','#003087','#00a8e0','#00c8ff','#5bc8f5'];

  function rand(min, max) { return min + Math.random() * (max - min); }

  /* ── PayPal particle field (continuous bubbles) ─────────────── */
  function spawnParticle(field) {
    var p = document.createElement('span');
    p.className = 'buy-particle';
    p.style.left  = rand(10, 90) + '%';
    p.style.setProperty('--drift', rand(-24, 24) + 'px');
    p.style.setProperty('--dur',   rand(0.8, 1.4) + 's');
    p.style.setProperty('--delay', rand(0, 0.3) + 's');
    p.style.width  = rand(3, 6) + 'px';
    p.style.height = p.style.width;
    field.appendChild(p);
    setTimeout(function () { p.remove(); }, 1800);
  }

  function startParticleLoop(field, interval) {
    var burst = function () {
      var count = Math.floor(rand(2, 5));
      for (var i = 0; i < count; i++) {
        (function (i) { setTimeout(function () { spawnParticle(field); }, i * 90); })(i);
      }
    };
    burst();
    return setInterval(burst, interval);
  }

  /* ── Bubble-wrap pop burst ──────────────────────────────────── */
  function spawnBubblePop(rect, isPaypal) {
    var count = Math.floor(rand(12, 18));
    var maxDelay = 0.55;

    for (var i = 0; i < count; i++) {
      (function (i) {
        var delay  = rand(0, maxDelay);
        var size   = rand(9, 24);
        var bx     = rand(-40, 40);
        var by     = rand(-45, 10);
        var cx     = rect.left + rand(0.08, 0.92) * rect.width;
        var cy     = rect.top  + rand(0.1,  0.9)  * rect.height;

        /* Bubble */
        var b = document.createElement('span');
        b.className = 'lg-bubble' + (isPaypal ? ' lg-bubble--paypal' : '');
        b.style.width  = size + 'px';
        b.style.height = size + 'px';
        b.style.left   = cx + 'px';
        b.style.top    = cy + 'px';
        b.style.setProperty('--bdur',   rand(0.38, 0.52) + 's');
        b.style.setProperty('--bdelay', delay + 's');
        b.style.setProperty('--bx', bx + 'px');
        b.style.setProperty('--by', by + 'px');
        document.body.appendChild(b);

        /* Ring */
        var r = document.createElement('span');
        r.className = 'lg-bubble lg-bubble--ring' + (isPaypal ? ' lg-bubble--paypal' : '');
        r.style.width  = size + 'px';
        r.style.height = size + 'px';
        r.style.left   = cx + 'px';
        r.style.top    = cy + 'px';
        r.style.setProperty('--bdur',   '0.5s');
        r.style.setProperty('--bdelay', (delay + 0.12) + 's');
        r.style.setProperty('--bx', '0px');
        r.style.setProperty('--by', '0px');
        document.body.appendChild(r);

        var cleanAfter = (delay + 0.65) * 1000;
        setTimeout(function () { b.remove(); r.remove(); }, cleanAfter);
      })(i);
    }
  }

  function init() {
    /* PayPal / dynamic checkout area */
    var payBtn = document.querySelector('.shopify-payment-button');
    if (payBtn) {
      var field = document.createElement('div');
      field.className = 'buy-particle-field';
      payBtn.style.position = 'relative';
      payBtn.appendChild(field);
      startParticleLoop(field, 900);

      payBtn.addEventListener('click', function (e) {
        var branded = payBtn.querySelector('.shopify-payment-button__button--branded');
        var rect = branded ? branded.getBoundingClientRect() : payBtn.getBoundingClientRect();
        spawnBubblePop(rect, true);
      });
    }

    /* Add to cart button — event delegation for dynamic re-renders */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.product-form__submit, button[name="add"]');
      if (!btn) return;
      var rect = btn.getBoundingClientRect();
      spawnBubblePop(rect, false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
